import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBpxMIzazFy7OVhidvX0b3kPMhk8mwnGQI",
  authDomain: "doctora-live-e4780.firebaseapp.com",
  projectId: "doctora-live-e4780",
  storageBucket: "doctora-live-e4780.firebasestorage.app",
  messagingSenderId: "832181054141",
  appId: "1:832181054141:android:4445405da3bfe8320e25d4"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);